<template>
  <div>

    <div style="display: flex; justify-content: space-between">
      <div>{{scope.row.name}}</div>

      <div>
        <el-button
          v-if="isFieldAvailableForEdit(scope.row, 'library_element_id')"
          type="text"
          class="table-action-button"
          icon="fas fa-search"
          @click="openLibrary"
        >
        </el-button>
        <el-button
          v-if="scope.row && scope.row.library_element_id && isFieldAvailableForEdit(scope.row, 'library_element_id')"
          type="text"
          class="table-action-button"
          icon="fas fa-unlink"
          @click="removeElementsFromLibrary"
        >
        </el-button>
      </div>

    </div>


    <element-add-from-library-dialog
      ref="addElementFromLibraryDialog"
      add-button-text="Выбрать"
      :from-card="card.id"
      @element-ids-selected="createElementsFromLibrary"
    >
    </element-add-from-library-dialog>

  </div>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
import {variables} from "@/componentsCompany/smz/variables";
import ElementAddFromLibraryDialog from "@/components/cards/CardElementsBlock/ElementAddFromLibraryDialog.vue";
import { mapGetters } from "vuex";
export default {
  name: 'astra-top-element-strategy-target-table-column',
  components: { ElementAddFromLibraryDialog, ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {
      scaleTypesEnum: variables.scaleTypesEnum,
    }
  },
  computed: {
    ...mapGetters('card', {
      card:'card'
    }),
  },
  methods: {
    openLibrary() {
      this.$refs.addElementFromLibraryDialog.open('library');
    },
    createElementsFromLibrary(ids){
      this.saveElementPropChange(this.scope.row, 'library_element_id', ids[0])
        .finally(() => {
          this.$refs.addElementFromLibraryDialog.close();
          this.$emit('elements-changed');
        })

    },
    removeElementsFromLibrary(){
      this.saveElementPropChange(this.scope.row, 'library_element_id', 0)
        .finally(() => {
          this.$emit('elements-changed');
        })

    },
  }
}

</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";

</style>
